var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import raf from 'raf';

var Notification = function (_React$Component) {
  _inherits(Notification, _React$Component);

  function Notification(props) {
    _classCallCheck(this, Notification);

    var _this = _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).call(this, props));

    _this.state = {
      persist: _this.props.persist,
      timeoutId: null
    };
    return _this;
  }

  _createClass(Notification, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // Wait two frames to ensure that the notification has rendered for the
      // animation to occur. Stupid browsers...
      this._raf = raf(function () {
        _this2._raf = raf(function () {
          _this2._raf = null;
          _this2.startTimeout();
        });
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopTimeout();
    }
  }, {
    key: 'startTimeout',
    value: function startTimeout() {
      var _this3 = this;

      if (this.state.persist) {
        return;
      }
      this.stopTimeout();
      var timeoutId = setTimeout(function () {
        return _this3.props.onClose();
      }, this.props.delay);
      this.setState({ timeoutId: timeoutId });
    }
  }, {
    key: 'stopTimeout',
    value: function stopTimeout() {
      if (this._raf) {
        raf.cancel(this._raf);
        this._raf = null;
      }
      if (this.state.timeoutId) {
        clearTimeout(this.state.timeoutId);
        this.setState({ timeoutId: null });
      }
    }
  }, {
    key: 'handleMouseEnter',
    value: function handleMouseEnter() {
      this.stopTimeout();
    }
  }, {
    key: 'handleMouseLeave',
    value: function handleMouseLeave() {
      this.startTimeout();
    }
  }, {
    key: 'handleClickClose',
    value: function handleClickClose() {
      this.props.onClose();
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      this.stopTimeout();
      this.setState({
        persist: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var className = 'cf-notifications__item';
      var progress = void 0;

      className += ' cf-notifications__item--' + this.props.type;

      if (this.state.persist) {
        className += ' cf-notifications__item--persist';
      } else {
        var progressClassName = 'cf-notifications__item_progress';
        var progressStyles = {};

        if (this.state.timeoutId) {
          progressClassName += ' cf-notifications__item_progress--active';
          progressStyles.transitionDuration = this.props.delay + 'ms';
        }

        progress = React.createElement('span', { className: progressClassName, style: progressStyles });
      }

      var close = void 0;

      if (this.props.closable) {
        close = React.createElement('span', {
          className: 'cf-notifications__item_close',
          onClick: this.handleClickClose.bind(this)
        });
      }

      return React.createElement(
        'div',
        {
          role: 'alert',
          className: className,
          onClick: this.handleClick.bind(this),
          onMouseEnter: this.handleMouseEnter.bind(this),
          onMouseLeave: this.handleMouseLeave.bind(this)
        },
        progress,
        close,
        React.createElement(
          'span',
          { className: 'cf-notifications__item_message' },
          this.props.message
        )
      );
    }
  }]);

  return Notification;
}(React.Component);

Notification.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'info', 'warning']),
  message: PropTypes.string.isRequired,

  closable: PropTypes.bool,
  delay: PropTypes.number,
  persist: PropTypes.bool,

  onClose: PropTypes.func.isRequired
};

Notification.defaultProps = {
  closable: true,
  delay: 4000,
  persist: false
};

export default Notification;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-notifications/es/Notification.js
// module id = 658
// module chunks = 0